module.exports = __webpack_public_path__ + "bd52679ac45cd5392895fee3a718993b.jpg";